exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-group-tip,.vux-group-tip p{font-size:14px;color:#888;text-align:center;padding-top:.3em;padding-left:10px;padding-right:5px}.vux-group-tip .weui-icon{padding-right:3px}", ""]);

// exports
